document.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth < 768) {
    setTimeout(() => {
      const productGrid = document.querySelector(".product-grid");
      if (!productGrid) return;

      const productBlocks = productGrid.querySelectorAll(".product-block");
      productBlocks.forEach((productBlock, index) => {
        if (index % 2 !== 0) return; // Process every pair starting from the first

        const nextProductBlock = productBlocks[index + 1];
        if (!nextProductBlock) return;

        // Process hiding sale price labels if applicable
        toggleSalePriceLabels(productBlock, nextProductBlock);

        // Adjust title heights if necessary
        adjustTitleHeights(productBlock, nextProductBlock);

        // Handle color swatches display adjustments
        adjustColorSwatches(productBlock, nextProductBlock);

        // Hide yotpo based on specific conditions
        hideYotpo(productBlock, nextProductBlock);
      });
    }, 2500); // Delay to ensure elements are loaded, adjust as needed

    setTimeout(() => {
      const productBlocks = document.querySelectorAll(
        ".collection-slider .collection-listing .product-list .custom-product-block"
      );

      // console.log("productBlocks", productBlocks);
      productBlocks.forEach((productBlock, index) => {
        // console.log(productBlock.querySelector(".yotpo").clientHeight);
        if (productBlock.querySelector(".yotpo").clientHeight === 0) {
          productBlock.querySelector(".yotpo").classList.add("yotpo-review-placeholder-mobile");
        }
        // productBlock.querySelector('yotpo').classList.add('hide-yotpo')
      });
    }, 2500);
  }
});

function toggleSalePriceLabels(productBlock, nextProductBlock) {
  const hasSale = (selector) =>
    selector.querySelector(".price-label--sale").innerText.trim() === "";
  if (hasSale(productBlock) && hasSale(nextProductBlock)) {
    productBlock.querySelector(".price-label--sale").classList.add("hide-price-label--sale");
    nextProductBlock.querySelector(".price-label--sale").classList.add("hide-price-label--sale");
  }
}

function adjustTitleHeights(productBlock, nextProductBlock) {
  const needsAdjustment = (selector) =>
    selector.querySelector(".product-block__title").clientHeight > 25;
  if (needsAdjustment(productBlock) || needsAdjustment(nextProductBlock)) {
    productBlock
      .querySelector(".product-block__title")
      .classList.add("product-block__title-set-min-height");
    nextProductBlock
      .querySelector(".product-block__title")
      .classList.add("product-block__title-set-min-height");
  }
}

function adjustColorSwatches(productBlock, nextProductBlock) {
  const hasManySwatches = (selector) =>
    selector.querySelectorAll(".color-swatch__wrapper .product-block-options--swatch").length >= 7;
  if (hasManySwatches(productBlock) || hasManySwatches(nextProductBlock)) {
    productBlock
      .querySelector(".color-swatch__wrapper")
      .classList.add("color-swatch__wrapper--more-than-five");
    nextProductBlock
      .querySelector(".color-swatch__wrapper")
      .classList.add("color-swatch__wrapper--more-than-five");
  }
}

function hideYotpo(productBlock, nextProductBlock) {
  const isYotpoHidden = (selector) => selector.querySelector(".yotpo")?.clientWidth === 0;
  if (isYotpoHidden(productBlock) && isYotpoHidden(nextProductBlock)) {
    productBlock.querySelector(".yotpo").classList.add("hide-yotpo");
    nextProductBlock.querySelector(".yotpo").classList.add("hide-yotpo");
  }
}
